import { required, email, requiredIf } from "vuelidate/lib/validators";

export const ValidationRulesEdit = {
  email: {
    required,
    email,
  },
  gb: {
    isVisible: {
      sameAs: (val) => val === true,
    },
    gb_name: {
      required: requiredIf(function (gb) {
        return gb.isVisible;
      }),
    },
    gb_lastname: {
      required: requiredIf(function (gb) {
        return gb.isVisible;
      }),
    },
    gb_street: {
      required: requiredIf(function (gb) {
        return gb.isVisible;
      }),
    },
    gb_number: {
      required: requiredIf(function (gb) {
        return gb.isVisible;
      }),
    },
    gb_plz: {
      required: requiredIf(function (gb) {
        return gb.isVisible;
      }),
    },
    gb_city: {
      required: requiredIf(function (gb) {
        return gb.isVisible;
      }),
    },
  },
  checkConditions: {
    sameAs: (val) => val === true,
  },
};